import React from 'react';
import { Navigate } from 'react-router-dom';
import Loader from '@hero/ui-kit/components/Loader';
import useIsMarketingAdmin from './hooks/useIsMarketingAdmin';

type Props = {
    children: React.ReactNode;
};

const MarkGuard: React.FC<Props> = ({ children }) => {
    const status = useIsMarketingAdmin();

    if (status === 'pending') return <Loader />;
    if (status === 'denied') return <Navigate to="/" replace />;
    return <>{children}</>;
};

export default MarkGuard;
